var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14508 0.927316L6.24699 1.51466L7.34891 0.927316H12.494V10.9273H7.6432L6.24699 11.6727L4.8502 10.9273H0V0.927316H5.14508ZM4.85017 2.26066H1.24941V9.59397H5.14508L5.6223 9.84835V2.67266L4.85017 2.26066ZM11.2446 2.26066H7.6432L6.87169 2.6725V9.84835L7.34894 9.59397H11.2446V2.26066ZM10.6199 6.26066V7.26066H7.49641V6.26066H10.6199ZM4.99761 6.26066V7.26066H1.8741V6.26066H4.99761ZM10.6199 3.59397V4.59397H7.49641V3.59397H10.6199ZM4.99761 3.59397V4.59397H1.8741V3.59397H4.99761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseBookIcon);
export default __webpack_public_path__ + "static/media/CourseBookIcon.8cf85d65fd4da877aa474035515512f1.svg";
export { ForwardRef as ReactComponent };